import { render, staticRenderFns } from "./fccAreaDetalhada.vue?vue&type=template&id=884dd070"
import script from "./fccAreaDetalhada.vue?vue&type=script&lang=js"
export * from "./fccAreaDetalhada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports